/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // Homepage Slider

  mobileOnlySlider(".mobile-slider", true, false, 767);
  function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
  var slider = $($slidername);
  var settings = {
    mobileFirst: true,
    dots: false,
    arrows: false,
    infinite: false,
    slidesToShow: 2.2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: $breakpoint,
        settings: "unslick"
      }
    ]
  };
  slider.slick(settings);
  
  $(window).on("resize", function () {
    if ($(window).width() > $breakpoint) {
      return;
    }
    if (!slider.hasClass("slick-initialized")) {
      return slider.slick(settings);
    }
  });
  } 

  // Open ZenDesk Live Chat with Icon Link (Contact Us Only)
  
  function setupClickListener() {
    const element = document.querySelector("#shopify-section-template--19148952076545__icons > div > div > div > div:nth-child(2) > div > div.icon__column__text > div > p > a"); // Open Chat JS Selector
    if (element) {
      element.addEventListener('click', (event) => {
        event.preventDefault();
        if (typeof zE === 'function') {
          zE('messenger', 'open');
        } else {
          // console.error('zE function is not defined.');
        }
      });
    } else {
      // console.error('Element a.text-dark.text-link not found.');
    }
  }
  setupClickListener();

  // Update Product Page Compare Price (Strikethrough) on Variant Change

  (function() {
    // 1. Locate the product JSON data (Standard Shopify pattern)
    const productJsonElement = Array.from(document.querySelectorAll('script[type="application/json"]'))
      .find(s => s.textContent.includes('"variants"') && s.textContent.includes('"compare_at_price"'));

    if (!productJsonElement) {
      // console.error('Product data not found.');
      return;
    }

    const productData = JSON.parse(productJsonElement.textContent);
    const comparePriceElement = document.querySelector('.product__price--compare');
    const variantInputs = document.querySelectorAll('input[name^="options"], select[name^="options"]');

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function updatePrice() {
      // 2. Get the currently selected options
      const selectedOptions = Array.from(document.querySelectorAll('input[name^="options"]:checked, select[name^="options"]'))
        .map(input => input.value);

      // 3. Find the variant that matches all selected options
      const variant = productData.variants.find(v => 
        v.options.every(opt => selectedOptions.includes(opt))
      );

      // 4. Update the compare-at price element
      if (variant && comparePriceElement) {
        if (variant.compare_at_price > variant.price) {
          comparePriceElement.textContent = formatMoney(variant.compare_at_price);
          comparePriceElement.style.display = 'inline';
        } else {
          // Hide if there is no discount for this variant
          comparePriceElement.style.display = 'none';
        }
      }
    }

    // 5. Attach event listeners
    variantInputs.forEach(input => {
      input.addEventListener('change', updatePrice);
    });

    // Initial run to set correct price on load
    updatePrice();
  })();

})();